import * as React from "react";
const SvgFiRrMountains = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mountains_svg__a)">
      <path
        fill="#062147"
        d="M20 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0-6a2 2 0 1 0 0 4 2 2 0 0 0 0-4m1.452 22H12.59a2.55 2.55 0 0 1-2.568-2.492 2.46 2.46 0 0 1 .318-1.239l4.436-7.959a2.6 2.6 0 0 1 4.5 0l4.425 7.953a2.47 2.47 0 0 1-.028 2.475A2.55 2.55 0 0 1 21.452 24m-4.429-11a.56.56 0 0 0-.5.283l-4.436 7.959a.47.47 0 0 0 .006.485.56.56 0 0 0 .5.273h8.863a.56.56 0 0 0 .5-.275.48.48 0 0 0 0-.489l-4.432-7.952a.56.56 0 0 0-.5-.284M8 23a1 1 0 0 0-1-1H3.35a1.35 1.35 0 0 1-1.184-1.994l6.652-12.3A1.33 1.33 0 0 1 10 7a1.33 1.33 0 0 1 1.183.706l1.227 2.267a1 1 0 0 0 1.84-.19 1 1 0 0 0-.08-.762l-1.226-2.266a3.343 3.343 0 0 0-5.885 0l-6.653 12.3A3.35 3.35 0 0 0 3.35 24H7a1 1 0 0 0 1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mountains_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMountains;
